import { PLAYER_REGEX } from '~/utils/constants'

export default function (context) {
  // If the player is not authenticated
  const { u } = context.query
  if (!!u && !PLAYER_REGEX.test(u)) {
    return context.redirect('/')
  }
}
